/* global Sentry */

LS.user = {
	/**
	 * Initialize module
	 */
	init() {
		if (window.crawler) {
			return;
		}

		const scope = LS.user;

		if (! scope.location()) {
			const loc = LS.location.get(true);

			if (loc && loc.slug) {
				loc.source = 'request';

				LS.store.set('user_location', loc);
			}
		}

		$.observe('user', data => {
			scope.toggle(Boolean(data.account));
		});

		scope.set();
	},

	/**
	 * Retrieve the currently authenticated user
	 *
	 * @param {String} [key]
	 * @returns {Object}
	 */
	get(key) {
		return $.get('user.account' + (key ? '.' + key : ''));
	},

	/**
	 * Populate user storage
	 *
	 * @param {Object} [data]
	 */
	set(data) {
		const scope = LS.user;

		if (data) {
			scope.setToken(data.token, data.ttl, data.refresh_ttl);

			data.account ?
				scope.setUser(data) :
				scope.fetchUser(data);
		} else if (! scope.active() && scope.token()) {
			scope.refreshToken();
		} else if (! scope.get()) {
			scope.fetchUser(data);
		}
	},

	/**
	 * Get user location
	 *
	 * @param {Boolean} [international=false]
	 * @returns {Object}
	 */
	location(international) {
		const loc = LS.store.get('user_location');

		return loc && (
			international ||
			loc.country === 'US'
		) ?
			loc : null;
	},

	/**
	 * Get user center
	 *
	 * @returns {Object}
	 */
	center() {
		const loc = LS.user.location();

		if (
			! loc ||
			! loc.latitude
		) {
			return null;
		}

		return [
			loc.longitude,
			loc.latitude
		];
	},

	/**
	 * Determine of token is valid
	 *
	 * @returns {Boolean}
	 */
	active() {
		return LS.store.get('user_id', null) !== null;
	},

	/**
	 * Check for restricted user consent
	 *
	 * @return {Boolean}
	 */
	restricted() {
		return navigator.globalPrivacyControl === true ||
			LS.store.get('consent') === false;
	},

	/**
	 * Ensure authenticated state before action
	 *
	 * @param {Function} fn
	 */
	guard(fn) {
		if (LS.user.active()) {
			$.exec(fn);

			return;
		}

		LS.user.renew(fn);
	},

	/**
	 * Process token renewal
	 *
	 * @param {Function} fn
	 */
	renew(fn) {
		const scope = LS.user;

		scope.token() ?
			scope.refreshToken(fn) :
			scope.resetToken(fn);
	},

	/**
	 * Get the auth token for the user session
	 *
	 * @param {Boolean} [parse=false]
	 * @returns {String}
	 */
	token(parse) {
		const token = LS.store.get('user_token');

		return parse ?
			LS.user.parseToken(token) :
			token;
	},

	/**
	 * Get the UID
	 *
	 * @returns {String}
	 */
	uid() {
		const key = 'analytics_uid';

		let uid = LS.store.get(key);

		if (! uid) {
			uid = LS.util.uid();

			LS.store.set(key, uid);
		}

		return uid;
	},

	/**
	 * Drop the authenticated user state
	 */
	drop() {
		$.drop('user.account');

		LS.store.drop('user_token');
		LS.store.drop('user_id');

		LS.user.toggle(false);
	},

	/**
	 * Fetch user data
	 */
	fetchUser() {
		const loc = LS.user.location();
		const data = {};

		if (! loc) {
			data.locate = 'y';
		}

		LS.api.get('me', {
			auth: true,
			cache: false,
			data: data,
			flash: false,
			guard: false,
			namespace: 'auth',
			success: resp => {
				LS.user.setUser(resp);
			}
		});
	},

	/**
	 * Set user data
	 *
	 * @param {Object} data
	 */
	setUser(data) {
		const scope = LS.user;

		let loc;

		if (data.location) {
			LS.store.set('user_location', data.location);
		} else {
			loc = scope.location();

			if (loc) {
				data.location = loc;
			}
		}

		if (scope.active() && ! data.account) {
			scope.drop();
		}

		$.set('user', data);
	},

	/**
	 * Refresh the auth token for the user session
	 *
	 * @param {Function} [fn]
	 */
	refreshToken(fn) {
		LS.api.post('auth/refresh', {
			auth: true,
			namespace: 'auth',
			flash: false,
			success: data => {
				LS.user.set(data);

				$.exec(fn);
			},
			error: () => {
				LS.user.resetToken(fn);
			}
		});
	},

	/**
	 * Force login to refresh token
	 *
	 * @param {Function} [fn]
	 */
	resetToken(fn) {
		LS.user.drop();

		Apt.auth.prompt(fn);
	},

	/**
	 * Set authentication references
	 *
	 * @param {String} token
	 * @param {Number} ttl
	 * @param {Number} refresh
	 */
	setToken(token, ttl, refresh) {
		LS.store.set('user_token', token, refresh);
		LS.store.set('user_id', LS.user.parseToken(token).sub, ttl);
	},

	/**
	 * Parse JSON web token
	 *
	 * @param {String} [token]
	 * @returns {Object}
	 */
	parseToken(token) {
		token = token || LS.user.token();

		if (! token) {
			return null;
		}

		return JSON.parse(
			window.atob(
				token.split('.')[1]
					.replace('-', '+')
					.replace('_', '/')
			)
		);
	},

	/**
	 * Toggle header account display
	 *
	 * @param {Boolean} [show=true]
	 */
	toggle(show = true) {
		const $auth = $$('loggedIn');

		$$('loggedOut').toggle(! show);

		if (show) {
			$auth.html($.view.get('_account'));
		}

		$auth.toggle(show);
	}
};